import { ref, watch } from 'vue';
import { useTheme as useVuetifyTheme } from 'vuetify';

const isDark = ref(false);

// Initialize from localStorage (runs once)
const stored = localStorage.getItem('darkMode');
if (stored === '1') {
  isDark.value = true;
} else if (stored === null && window.matchMedia('(prefers-color-scheme: dark)').matches) {
  isDark.value = true;
}

export function useTheme() {
  let vuetifyTheme: ReturnType<typeof useVuetifyTheme> | null = null;

  try {
    vuetifyTheme = useVuetifyTheme();
  } catch {
    // Outside Vuetify context — CSS vars still work
  }

  function applyTheme() {
    const root = document.documentElement;

    // 1. Toggle HTML class for CSS-based dark mode
    root.classList.toggle('dark', isDark.value);

    // 2. Switch Vuetify theme (for legacy pages using var(--v-*))
    if (vuetifyTheme) {
      vuetifyTheme.global.name.value = isDark.value ? 'dark' : 'light';
    }

    // 3. Update meta theme-color for iOS status bar
    const meta = document.querySelector('meta[name="theme-color"]');
    if (meta) {
      meta.setAttribute('content', isDark.value ? '#0f0f0f' : '#FEFCF9');
    }

    // 4. Persist
    localStorage.setItem('darkMode', isDark.value ? '1' : '0');
  }

  function toggleTheme() {
    isDark.value = !isDark.value;
  }

  // Watch for changes and apply
  watch(isDark, applyTheme, { immediate: true });

  return {
    isDark,
    toggleTheme,
  };
}
